// extracted by mini-css-extract-plugin
export var wrapper = "promo-module--wrapper--uStgC";
export var small = "promo-module--small--dB9ep";
export var medium = "promo-module--medium--BOW5G";
export var slideUp = "promo-module--slideUp--wG3R9";
export var slideUpLarge = "promo-module--slideUpLarge--++2on";